import {
  CameraModel,
  ControlModel,
  InputModel,
  UserModel,
  UpdateUserModel,
  ControlTypeModel,
  SensorTypeModel,
  CameraBrandModel,
  MediaModel,
  InputTypeModel,
  RelationModel,
  GatewayCommand,
  GatewayInfoModel,
  CameraResolution,
  CallListModel,
  ControlIconTypeModel,
} from "../types/control";
import {BridgeDeviceModel} from "../types/bridge-device";
import {ClientTask} from "./client-task";
import {
AlarmStateModel,
AreaModel,
ConfigModel,
CreateMediaDeviceModel,
MediaInputModel,
VirtualControlModel,
ScenarioModel,
ScenarioTriggerModel,
HomepageItemModel,
SoundState,
UpdateFCMPushTokenRequest,
MenuEntity,
STPUIEntity,
LanguageModel,
IftttState,
ScreenState,
LogListType,
UserLogListType,
ProjectInfo,
ProjectInfoDetails,
ProjectInfoList,
EnergyModel,
EnergyAnalyzerModel,
MessageListType,
AnswerMessage,
ConnectionIcons,
IFTTTResponse, SetLanguage, AnswerIntercomType, CallLogList, SystemInfoTest, SoundPlayingStatus, SecurityCodeType, AuthorityModel, AuthorityOverviewList, DateState, TimezoneType, AlarmLogs, AsyncAlarmState, SIPBlockedNumbersState, TempLogType, BoosterModel, SIPFormatType, NotificationLogType,
SunTimeType, DetailedRFTestModel, FrameUIEntity,
SortingItemModel,
SystemRestart,
WorkerConfigPanelSettings,
OnboardingUser, AuthenticatedWithPinCodeResponse,
MenuIconModel
} from "../store/control/state";
import { WS } from "../utils/ws";
import { SettingsModel } from "../store/settings/state";
import { IntercomModel } from "../types/intercom";
import { DoorModel } from "../types/door";
import { RPCService as BaseRPCService } from "../base/RPCService";
import { Configs } from "../configs";
import { MediaFileModel } from "../store/ui/state";
import { GatewayModel } from "../types/gateway";
import { DoorBrandModel } from "../types/door-brand";
import { BridgeDeviceTypeModel } from "../types/bridge-device-type";
import { WifiNetworkModel } from "../types/wifi-network";
import { SystemInfo } from "../types/system-info";
import { LocationModel } from "../types/location";
import { TemperatureMessage } from "../store/temperature/state";
import { ConciergeModel } from "../types/concierge";
import { ConciergeTypeModel } from "../types/concierge-type";
import { RgbColor } from "../components/ColorPicker/types";
import { WorkerConfigModel } from "../types/worker-config";
import { AutoRestart, SupervisorConfigModel } from "../types/supervisor-config";
import { SpeedTestModel } from "../types/network";
import { RFTestLogType } from "../types/logs";
import { LucentRGBSettingsModel } from "../types/lucent-rgb-settings";
import { AnalogSensorTypeModel } from "../types/analog-sensor";

export class RPCService extends BaseRPCService<ClientTask> {
  public constructor(client: ClientTask, websocket: WS) {
      super(client, websocket);
  }

  public test() {
      return this.ask("Test");
  }

  public IncomingOuterPanelRing(name: number, command: string) {
      return this.ask("IncomingOuterPanelRing", {name, command});
  }

  public SetClickSound(status: boolean) {
      return this.ask("SetClickSound", status)
  }

  public IncomingFlatFrontRing(name: number, command: string) {
      return this.ask("IncomingFlatFrontRing", {name, command});
  }

  public ping() {
      return this.ask("Ping")
  }

  public sendBrokenLink(link: string) {
      return this.ask<string>("SendBrokenLink", {link});
  }

  public testNotification(os: string, token: string) {
      return this.ask<string>("TestNotification", {os, token});
  }

  public connectToMachine(
      address: string,
      username: string,
      password: string,
      id: string
  ) {
      return this.ask<string>("ConnectToMachine", {
          address,
          username,
          password,
          id,
      });
  }

  public beforeConnectToMachine(
      address: string,
      username: string,
      password: string
  ) {
      return this.ask<{ data: GatewayInfoModel[] }>("BeforeConnectToMachine", {
          address,
          username,
          password,
      });
  }

  public connectToLocalMachine() {
      return this.ask<string>("ConnectToLocalMachine");
  }

  public downloadDB() {
      return this.ask<{ data: string }>("DownloadDB").then((r) => r.data);
  }

  public uploadDB(data: unknown) {
      return this.ask<{ data: string }>("UploadDB", {data});
  }

  public resetDB() {
      return this.ask("ResetDB");
  }

  public getUserList() {
      return this.ask<{ data: UserModel[] }>("GetUserList").then((r) =>
          r.data.sort((a, b) => (a.id > b.id ? -1 : 1))
      );
  }

public getSTPUIList() {
  return this.ask<{ data: STPUIEntity[] }>("GetSTPUIList").then((r) =>
    r.data.sort((a, b) => (a.id > b.id ? -1 : 1))
  );
}

public getUITheme() {
  return this.ask<{ data: string }>("GetWorkerConfigPanelSettings").then((r) => {
    return r['panel_theme']
  })
}

public getPanelLanguage(): Promise<string> {
  return this.ask<{ data: string }>("GetPanelLanguage").then((r) => {
    return r['selected_language']
  })
}

public getLanguageList() {
  return this.ask<{ data: LanguageModel[] }>("GetLanguageList").then((r) =>
    r.data.sort((a, b) => (a.id > b.id ? -1 : 1))
  );
}
public getConciergeList() {
  return this.ask<{ data: ConciergeModel[] }>("GetConciergeList").then((r) =>
    r.data.sort((a, b) => (a.id > b.id ? -1 : 1))
  );
}

  public getConciergeTypeList() {
      return this.ask<{ data: ConciergeTypeModel[] }>(
          "GetConciergeTypeList"
      ).then((r) => r.data.sort((a, b) => (a.id > b.id ? -1 : 1)));
  }

  public getControlTypeList() {
      return this.ask<{ data: ControlTypeModel[] }>("GetControlTypeList").then(
          (r) =>
              r.data
                  .map((type) => {
                      for (const name in type.image_set) {
                          // noinspection JSUnfilteredForInLoop
                          type.image_set[name] =
                              Configs.IMAGE_PREFIX + type.image_set[name];
                      }

                      return type;
                  })
                  .sort((a, b) => (a.id > b.id ? -1 : 1))
      );
  }

  public getControlIconTypeList() {
    return this.ask<{ data: ControlIconTypeModel[] }>("GetControlIconTypeList").then(
      (r) => r.data
    );
}

    public updateControlIconType(iconTypes: ControlIconTypeModel[]){
        return this.ask<string>("UpdateControlIconType", iconTypes);
    }

  public getSensorTypeList() {
      return this.ask<{ data: SensorTypeModel[] }>("GetSensorTypeList").then(
          (r) =>
              r.data
                  .map((type) => {
                      for (const name in type.image_set) {
                          // noinspection JSUnfilteredForInLoop
                          type.image_set[name] =
                              Configs.IMAGE_PREFIX + type.image_set[name];
                      }

                      return type;
                  })
                  .sort((a, b) => (a.id > b.id ? -1 : 1))
      );
  }

  public getControlList() {
      return this.ask<{ data: ControlModel[] }>("GetControlList")
          .then((r) => r.data != null ? r.data.sort((a, b) => a.name.localeCompare(b.name)) : r.data) //to do (ordered)
          .then((controls) => controls != null &&
              controls.map((control) => {
                  if (control.temperature_settings != null) {
                      control.temperature_settings.whole =
                          control.temperature_settings.whole || 14;
                      if (control.temperature_settings.whole === 14) {
                          control.temperature_settings.fraction = 5;
                      }
                  }

                  return control;
              })
          );
  }

  public getCameraList() {
      return this.ask<{ data: CameraModel[] }>("GetCameraList").then((r) =>
          r.data.sort((a, b) => a.name.localeCompare(b.name))
      );
  }

  public getCameraBrandList() {
      return this.ask<{ data: CameraBrandModel[] }>("GetCameraBrandList").then(
          (r) => r.data.sort((a, b) => (a.id > b.id ? -1 : 1))
      );
  }

  public getMediaFileList() {
      return this.ask<{ data: MediaFileModel[] }>("GetMediaFileList").then((r) =>
          r.data.sort((a, b) => (a.id > b.id ? -1 : 1))
      );
  }

  public getScenarioList() {
      return this.ask<{ data: ScenarioModel[] }>("GetScenarioList").then((r) =>
          r.data.sort((a, b) => a.name.localeCompare(b.name))
      );
  }

  public getScenarioTriggerList() {
      return this.ask<{ data: ScenarioTriggerModel[] }>(
          "GetScenarioTriggerList"
      ).then((r) => r.data.sort((a, b) => a.name.localeCompare(b.name)));
  }

  public getDoorList() {
      return this.ask<{ data: DoorModel[] }>("GetDoorList")
          .then((r) => r.data.sort((a, b) => a.name.localeCompare(b.name)))
          .then((r) => r.map((d) => ({...d, toString: () => d.id})));
  }

  public getDoorBrandList() {
      return this.ask<{ data: DoorBrandModel[] }>("GetDoorBrandList").then((r) =>
          r.data.sort((a, b) => (a.id > b.id ? -1 : 1))
      );
  }

  public getIntercomList() {
      return this.ask<{ data: IntercomModel[] }>("GetIntercomList").then((r) =>
          r.data.sort((a, b) => a.name.localeCompare(b.name))
      );
  }

  public getInputTypeList() {
      return this.ask<{ data: InputTypeModel[] }>("GetInputTypeList")
          .then((r) => r.data.filter((c) => !c.registered_by_system))
          .then((r) => r.sort((a, b) => (a.id > b.id ? 1 : -1)));
  }

  public getInputList() {
      return this.ask<{ data: InputModel[] }>("GetInputList")
          .then((r) => r.data.filter((c) => !c.registered_by_system))
          .then((r) => r.sort((a, b) => a.name.localeCompare(b.name)));
  }

  public getAreaList() {
      return this.ask<{ data: AreaModel[] }>("GetAreaList").then((r) =>
          r.data.sort((a, b) => a.name.localeCompare(b.name))
      );
  }

  public getMediaList() {
      return this.ask<{ data: MediaModel[] }>("GetMediaList").then((r) =>
          r.data.sort((a, b) => a.name.localeCompare(b.name))
      );
  }

  public getWifiNetworkList(gatewayId: string) {
      return this.ask<{ data: WifiNetworkModel[] }>(
          "GetWifiNetworkList",
          gatewayId
      ).then((r) => r.data.sort((a, b) => (a.name > b.name ? 1 : -1)));
  }

  public getLocationList() {
      return this.ask<{data: LocationModel[]}>("GetLocationListV2").then(r => r.data)
  }

  public getTemperature() {
      return this.ask<TemperatureMessage>("GetTemperature");
  }

  public connectWifiNetwork(gatewayId: string, name: string, password: string) {
      return this.ask("ConnectWifiNetwork", {
          gateway_id: gatewayId,
          name,
          password,
      });
  }

  public disconnectWifiNetwork(gatewayId: string) {
      return this.ask("DisconnectWifiNetwork", {gateway_id: gatewayId});
  }

  public getMediaInputList() {
      return this.ask<{ data: MediaInputModel[] }>("GetMediaInputList").then(
          (r) => r.data.sort((a, b) => (a.id > b.id ? -1 : 1))
      );
  }

  public getVirtualControlList() {
      return this.ask<{ data: VirtualControlModel[] }>("GetVirtualControlList")
          .then((r) => r.data /*.filter(c => !c.registered_by_system)*/)
          .then((r) => r.sort((a, b) => (a.id > b.id ? -1 : 1)));
  }

  public getHomepageItemList() {
      return this.ask<{ data: HomepageItemModel[] }>("GetHomepageItemList").then(
          r => r.data.filter(item => item !== null).sort((a, b) => (a.order > b.order ? -1 : 1))
      );
  }

  public getBridgeDeviceList() {
      return this.ask<{ data: BridgeDeviceModel[] }>("GetBridgeDeviceList").then(
          (r) => r.data.sort((a, b) => (a.id > b.id ? -1 : 1))
      );
  }

  public getBridgeDeviceTypeList() {
      return this.ask<{ data: BridgeDeviceTypeModel[] }>(
          "GetBridgeDeviceTypeList"
      ).then((r) =>
          r.data
              .map((type) => {
                  for (const name in type.image_set) {
                      // noinspection JSUnfilteredForInLoop
                      type.image_set[name] = Configs.IMAGE_PREFIX + type.image_set[name];
                  }

                  return type;
              })
              .sort((a, b) => a.name.localeCompare(b.name))
      );
  }

  public getGatewayList() {
      return this.ask<{ data: GatewayModel[] }>("GetGatewayList").then((r) =>
          r.data.sort((a, b) => a.name.localeCompare(b.name))
      );
  }

  public getMenuList() {
      return this.ask<{ data: MenuEntity[] }>("GetMenuList").then((r) => r.data);
  }

  public getMenuIconList() {
      return this.ask<{ data: MenuIconModel[] }>("GetMenuIconList").then((r) => r.data);
  }

  public getAlarmState() {
      return this.ask<AlarmStateModel>("GetAlarmState");
  }

  public getSoundState() {
      return this.ask<SoundState>("GetSoundState");
  }

  public getIftttState() {
      return this.ask<IftttState>("GetIFTTTState");
  }

  public getSystemInfo() {
      return this.ask<SystemInfo>("GetSystemInfo");
  }

  public scanDevices(gateway_id: string, is_auto: boolean) {
      return this.ask("ScanDevices", {gateway_id, is_auto});
  }

  public findDevice(
      gateway_id: string,
      unique_device_id: string,
      is_stop: boolean
  ) {
      return this.ask("FindDevice", {gateway_id, unique_device_id, is_stop});
  }

  public matchDevice(
      gateway_id: string,
      unique_device_id: string,
      device_id: string
  ) {
      return this.ask("MatchDevice", {gateway_id, unique_device_id, device_id});
  }

  public reMatchDevice(
      gateway_id: string,
      unique_device_id: string,
      device_id: string
  ) {
      return this.ask("ReMatchDevice", {
          gateway_id,
          unique_device_id,
          device_id,
      });
  }

  public resetDevice(gateway_id: string, unique_device_id: string, force_delete_matched_info: boolean) {
      return this.ask("ResetDevice", {gateway_id, unique_device_id, force_delete_matched_info});
  }

  public versionInfo(gateway_id: string, unique_device_id: string) {
      return this.ask("CheckDeviceVersion", {gateway_id, unique_device_id})
  }

  public CheckHardwareVersionCompatibility(gateway_id: string, device_type_id: string, version: string) {
        return this.ask("CheckHardwareVersionCompatibility", {gateway_id, device_type_id, version})
  }

  public getAllHardwareDeviceVersions() {
    return this.ask<{
        device_type_id: {
            [key: string]: Array<{
                id: string;
                device_name: string;
                version: string;
                description: string;
                error_level: 'green' | 'yellow' | 'red';
                created_timestamp: number;
                updated_timestamp: number;
            }>;
        };
        last_local_update_timestamp: number;
    }>("GetAllHardwareDeviceVersions");
}

public UpdateDeviceVersionsInfo() {
    return this.ask("UpdateDeviceVersionsInfo",{});
} 
  
  public rssiInfo(gateway_id: string, unique_device_id: string) {
      return this.ask("CheckDeviceRSSI", {gateway_id, unique_device_id})
  }

  public getSettings() {
      return this.ask<SettingsModel>("GetSettings");
  }

  public getConfigs() {
      return this.ask<ConfigModel>("GetConfigs");
  }

  public updateSoundLevel = (level: number) => {
      return this.ask<string>("UpdateSoundLevel", level);
  };

  public updateSoundState = (soundState: SoundState) => {
      return this.ask<string>("UpdateSoundState", soundState);
  };

  public setIftttState = (iftttState: IftttState) => {
      return this.ask<string>("SetIFTTTSettings", iftttState).catch(console.log);
  };

  public updateFCMPushToken = (request: UpdateFCMPushTokenRequest) => {
      return this.ask<string>("UpdateFCMPushToken", request);
  };

  public updateControlValue = (id: string, value: number) => {
      return this.ask<string>("UpdateControlValue", {id, value}).then(() => true)
  };

  public updateRGBControlValue = (id: string, value: number, color: RgbColor) => {
      return this.ask<string>("UpdateRGBControlValue", {id, value, color}).then(() => true);
  };

  public updateScenarioTriggerControl = (id: string, scenario_id: string, reverse_operation_type: string) => {
      return this.ask<string>("UpdateScenarioTriggerControl", {
          id,
          scenario_id,
          reverse_operation_type
      });
  };

public updateTemperature = (id: string, whole: number, fraction: number) => {
  return this.ask<string>("UpdateTemperature", { id, whole, fraction })
};

public updateWindSpeed = (id: string, windSpeed: number) => {
  return this.ask<string>("UpdateSensorControlValue", { id, value: windSpeed})
};

  public changeHeatingMode = (id: string) => {
      return this.ask<string>("ChangeHeatingMode", id)
  };

  public mediaButtonPressed(
      id: string,
      slot: number,
      extra: { [key: string]: any } = {}
  ) {
      this.ask<string>("MediaButtonPressed", {id, slot, ...extra}).catch(
          console.log
      );
  }

  public registerMediaInput(id: string) {
      return this.ask<string>("RegisterMediaInput", id);
  }

  public updateSensorStatus(
      id: string,
      is_active: boolean,
      is_control: boolean
  ) {
      this.ask<string>("UpdateSensorStatus", {id, is_active, is_control}).catch(
          console.log
      );
  }

  public updateNotificationStatus(
      id: string,
      is_notification: boolean
  ) {
      this.ask<string>("UpdateNotificationStatus", {
          id,
          is_notification
      }).catch(console.log);
  }

  public updateSensorCameraMatch(
      sensorId: string,
      cameraId: string
  ) {
      this.ask<string>("UpdateSensorCameraMatch", {
          sensor_id: sensorId,
          camera_id: cameraId
      }).catch(console.log);
  }

  public sendUartMessage(message: string) {
      this.ask<string>("SendUartMessage", message).catch(console.log);
  }

  public answerIntercomRequest(status: AnswerIntercomType) {
      this.ask("AnswerIntercomRequest", status).catch(console.log);
  }

  public callIntercom(request: string) {
      return this.ask("CallIntercom", request).catch(console.log);
  }

  public createConciergeRequest(id: string, message: string) {
      return this.ask("CreateConciergeRequest", {id, message});
  }


  public openDoor(id: string) {
      this.ask("OnDoorOpen", id).catch(console.log);
  }

  public updateScenario(scenarioModel: ScenarioModel) {
      return this.ask("UpdateScenario", scenarioModel)
          .then(() => true)
          .catch(() => false);
  }

  public updateUser(userModel: UpdateUserModel) {
      return this.ask("UpdateUser", userModel);
  }

  public updateSTPUI(stpUIEntity: STPUIEntity) {
      return this.ask("UpdateSTPUI", stpUIEntity);
  }

  public updateGateway(gatewayModel: GatewayModel) {
      return this.ask("UpdateGateway", gatewayModel);
  }

  public updateConfigs(configModel: ConfigModel) {
      return this.ask("UpdateConfigs", configModel);
  }

  public updateBridgeDevice(bridgeDevice: BridgeDeviceModel) {
      return this.ask("UpdateBridgeDevice", bridgeDevice);
  }

  public updateInput(input: InputModel) {
      return this.ask("UpdateInput", input);
  }

  public updateArea(area: AreaModel) {
      return this.ask("UpdateArea", area);
  }

  public updateIntercom(e: IntercomModel) {
      return this.ask("UpdateIntercom", e);
  }

  public updateHomepageItem(e: HomepageItemModel) {
      return this.ask("UpdateHomepageItem", e);
  }

  public updateMenu(e: MenuEntity) {
      return this.ask("UpdateMenu", e);
  }

  public updateDoor(e: DoorModel) {
      return this.ask("UpdateDoor", e);
  }

  public updateConcierge(e: ConciergeModel) {
      return this.ask("UpdateConcierge", e);
  }

  public updateDoorBrand(e: DoorBrandModel) {
      return this.ask("UpdateDoorBrand", e);
  }

  public updateMediaInput(input: MediaInputModel) {
      return this.ask("UpdateMediaInput", input);
  }

  public updateControl(controlModel: ControlModel) {
      return this.ask<string>("UpdateControl", controlModel);
  }

  public updateControlType(controlTypeModel: ControlTypeModel<unknown>) {
      for (const name in controlTypeModel.image_set) {
          // noinspection JSUnfilteredForInLoop
          controlTypeModel.image_set[name] = controlTypeModel.image_set[
              name
              ].replace(Configs.IMAGE_PREFIX, "");
      }

      return this.ask<string>("UpdateControlType", controlTypeModel);
  }

  public updateVirtualControl(virtualControl: VirtualControlModel) {
      return this.ask("UpdateVirtualControl", virtualControl);
  }

  public updateCamera(camera: CameraModel) {
      return this.ask("UpdateCamera", camera);
  }

  public updateCameraBrand(cameraBrand: CameraBrandModel) {
      return this.ask("UpdateCameraBrand", cameraBrand);
  }

  public updateScenarioTrigger(scenarioTriggerModel: ScenarioTriggerModel) {
      return this.ask("UpdateScenarioTrigger", scenarioTriggerModel)
          .then(() => true)
          .catch(() => false);
  }

  public createMediaDevice(
      mediaDevice: CreateMediaDeviceModel
  ): Promise<MediaModel> {
      return this.ask<MediaModel>("CreateMediaDevice", mediaDevice);
  }

  public getRelations(relational_id: string, type: string) {
      return this.ask<{ data: RelationModel[] }>("GetRelations", {
          relational_id,
          type,
      });
  }

  public deleteMedia(id: string) {
      return this.ask("DeleteMedia", id);
  }

  public deleteControl(id: string) {
      return this.ask("DeleteControl", id);
  }

  public deleteBridgeDevice(id: string) {
      return this.ask("DeleteBridgeDevice", id);
  }

  public deleteInput(id: string) {
      return this.ask("DeleteInput", id);
  }

  public deleteArea(id: string) {
      return this.ask("DeleteArea", id);
  }

  public deleteIntercom(id: string) {
      return this.ask("DeleteIntercom", id);
  }

  public deleteHomepageItem(id: string) {
      return this.ask("DeleteHomepageItem", id);
  }

  public deleteMenu(id: string) {
      return this.ask("DeleteMenu", id);
  }

  public deleteDoor(id: string) {
      return this.ask("DeleteDoor", id);
  }

  public deleteConcierge(id: string) {
      return this.ask("DeleteConcierge", id);
  }

  public deleteDoorBrand(id: string) {
      return this.ask("DeleteDoorBrand", id);
  }

  public deleteMediaInput(id: string) {
      return this.ask("DeleteMediaInput", id);
  }

  public deleteVirtualControl(id: string) {
      return this.ask("DeleteVirtualControl", id);
  }

  public deleteCamera(id: string) {
      return this.ask("DeleteCamera", id);
  }

  public playScenario(scenarioId: string) {
      this.ask("PlayScenario", scenarioId).catch(console.log);
  }

  public playReverseScenario(scenarioId: string) {
      this.ask("PlayReverseScenario", scenarioId).catch(console.log)
  }

  public stopScenario() {
      this.ask("StopScenario").catch(console.log);
  }

  public deleteScenario(scenarioId: string) {
      return this.ask("DeleteScenario", scenarioId).catch(console.log);
  }

  public deleteUser(userId: string) {
      return this.ask("DeleteUser", userId);
  }

  public deleteSTPUI(stpUIId: string) {
      return this.ask("DeleteSTPUI", stpUIId);
  }

  public deleteGateway(gatewayId: string) {
      return this.ask("DeleteGateway", gatewayId);
  }

  public deleteScenarioTrigger(scenarioTriggerId: string) {
      return this.ask("DeleteScenarioTrigger", scenarioTriggerId).catch(
          console.log
      );
  }

  public setAlarm(level: number, password: string) {
      return this.ask<boolean>("SetAlarm", {level, password})
          .then((response) => response)
          //.catch(() => false); todo is working?
  }

  public setAlarmV2(level: number, password: string) {
      return this.ask<boolean>("SetAlarmV2", {level, password})
          .then((response) => response)
          //.catch(() => false); todo is working?
  }

  public CheckAlarmPassword(password: string) {
      return this.ask<boolean>("CheckAlarmPassword", password).then(res => res);
  }

  public checkAlarmPasswordV2(password: string) {
      return this.ask("CheckAlarmPasswordV2", password)
  }

  public authenticate(username: string, password: string, security_control?: string, security_code?: string) {
      return this.ask("Authenticate", {username, password, security_control, security_code})
  }

  public updateTimeAndWeather(
      time: number,
      offset: number,
      temperature = -1,
      icon = -1
  ) {
      return this.ask("UpdateTimeAndWeather", {
          time,
          offset,
          temperature,
          icon,
      });
  }

  public broadcastTimeAndWeather() {
      return this.ask("BroadcastTimeAndWeather");
  }

  public getRTC() {
      return this.ask("GetRTC");
  }

  public clickSound() {
      return this.ask("ClickSound");
  }

  public touchEvent() {
      this.clickSoundOn()
      this.clickSound()
      return this.ask("TouchEvent");
  }


  public clickSoundOn() {
      return this.ask("ClickSoundOn");
  }

  public setDirectOutput(
      gateway_id: string,
      unique_device_id: string,
      slot: number,
      value: number
  ) {
      return this.ask("SetDirectOutput", {
          gateway_id,
          unique_device_id,
          slot,
          value,
      });
  }

  public getDirectInput(
      gateway_id: string,
      unique_device_id: string,
      slot: number
  ) {
      return this.ask<number>("GetDirectInput", {
          gateway_id,
          unique_device_id,
          slot,
      });
  }

  public manageGateway(id: string, command: GatewayCommand) {
      return this.ask("ManageGateway", {id, command});
  }

  public simpleConnectionRestartServices(id: string, command: GatewayCommand) {
        return this.ask("SimpleConnectionRestartServices", {id, command});
  }

  public doLogout() {
      return this.ask("DoLogout");
  }

  public authenticateTimeout() {
      return this.ask("AuthenticateTimeout");
  }

  public acceptUartLogs(acceptUartLogs: boolean) {
      return this.ask("AcceptUartLogs", acceptUartLogs);
  }

  public groupScriptCommand(area_id: string, status: boolean) {
      return this.ask("GroupScriptCommand", {
          area_id,
          status,
          control_type: "all",
      });
  }

  public getScreenState() {
      return this.ask<ScreenState>("GetScreenState");
  }

  public getScreenPinCodeState() {
      return this.ask<ScreenState>("GetScreenPinCodeState")
  }

  public updateScreenBrightness = (brightness: number) => {
      return this.ask<string>("SetScreenBrightness", brightness)
  };

  public updateScreenSleepBrightness = (brightness: number) => {
      return this.ask<string>("SetScreenSleepBrightness", brightness)
  };

  public updateScreenSaverTime = (saverTime: number) => {
      return this.ask<string>("SetScreenSaverTime", saverTime)
  };

  public updateScreenSleepTime = (sleepTime: number) => {
      return this.ask<string>("SetScreenSleepTime", sleepTime)
  };

  public updateScreenSaverType = (saverType: string) => {
      return this.ask<string>("SetScreenSaverType", saverType)
  };

  public updateRotateType = (rotateType: string) => {
      return this.ask<string>("SetRotateType", rotateType)
  };

  public updateScreenSaverState = (saverState: boolean) => {
      return this.ask<string>("SetScreenSaverState", saverState)
  };

  public updateScreenPinCodeState = (pinScreen: boolean) => {
      return this.ask<string>("SetScreenPinCodeState", pinScreen)
  };

  public updateScreenPinCodeTime = (pinScreen: number) => {
      return this.ask<string>("SetScreenPinCodeTime", pinScreen)
  };

  public setTheme(name: string) {
      return this.ask("SetPanelTheme", name)
  }

  public UploadTBellImage(base64Image: string) {
      return this.ask("UploadTBellImage", base64Image).then(res => res);
  }

  public GetLogList() {
      return this.ask<{ data: LogListType[] }>("GetLogList").then(r => r.data) //to do id control
  }

  public DownloadLog(data: LogListType) {
      return this.ask<{ data: string }>("DownloadLog", data).then(r => r.data)
  }

  public UpdateFanCoilTemperature = (id: string, whole: number, fraction: number, power_status: boolean, fan_speed: string, mode: boolean, ventilate: boolean) => {
      return this.ask<string>("UpdateFanCoilTemperature", {
          id,
          whole,
          fraction,
          mode,
          fan_speed,
          power_status,
          ventilate
      })
  };

  public deleteMediaFile(id: string) {
      return this.ask("DeleteMediaFile", id);
  }

  public GetUserLogList() {
      return this.ask<{ data: UserLogListType[] }>("GetUserLogList").then(r => r.data.sort((a, b) => a?.timestamp > b?.timestamp ? 1 : -1))
  };

  public GetDeviceRFSignalStrength() {
      return this.ask("GetDeviceRFSignalStrength")
  };

  public GetSecurityCode() {
      return this.ask<{data: SecurityCodeType}>("GetSecurityCode").then(r => r.data)
  };

  public getProjectInformationt(){
      return this.ask<{data: ProjectInfoList[]}>("GetProjectInformationList").then(r => r.data)
  };

  public updateProjectInformation(projectInformationList: ProjectInfo) {
      return this.ask("UpdateProjectInformation", projectInformationList)
  };

  public updateProjectExplanation(projectInformation: ProjectInfoDetails) {
      return this.ask("UpdateProjectExplanation", projectInformation)
  };

  public updateEnergyInformation(energyState: EnergyAnalyzerModel){
      return this.ask<string>("EnergyMonitorSaveConfig", energyState)
  };

  public getEnergyMonitorGetConfig(){
      return this.ask<{data: EnergyAnalyzerModel}>("EnergyMonitorGetConfig").then(r => r.data)
  };

  public GetEnergyMonitorHourly(control: object){
      return this.ask<{data: EnergyModel[]}>("EnergyMonitorHourly", control).then(r => r.data)
  };

  public GetEnergyMonitorDaily(control: object){
      return this.ask<{data: EnergyModel[]}>("EnergyMonitorDaily", control).then(r => r?.data?.sort((a, b) => (a?.day > b?.day ? 1 : -1)))
  };

  public GetEnergyMonitorMonthly(control: object){
      return this.ask<{data: EnergyModel[]}>("EnergyMonitorMonthly", control).then(r => r.data)
  };

  public EnergyHourlyStatistics(date:string) {
      return this.ask<{data: EnergyModel[]}>("EnergyMonitorHourlyStatistics", date).then(r => r.data)
  };

  public EnergyDailyStatistics(date:string){
      return this.ask<{data: EnergyModel[]}>("EnergyMonitorDailyStatistics", date).then(r => r.data)
  };

  public EnergyMonthlyStatistics(date:string){
      return this.ask<{data: EnergyModel[]}>("EnergyMonitorMonthlyStatistics", date).then(r => r.data)
  };
  public GetMessageList(){
      return this.ask<{data?: MessageListType}>("GetMessageList").then(r => r?.data)
  };

  public SetAnswerMessage(data: AnswerMessage){
      return this.ask("AnswerMessage", data).then(r => r)
  };

  public GetConnIcons() {
      return this.ask<{ data: ConnectionIcons }>("GetConnIcons").then(r => r?.data)
  };

  public ScanTemperatureSensor() {
      return this.ask("ScanTemperatureSensor");
  }

  public DefaultTemperatureSensor() {
      return this.ask("DefaultTemperatureSensor");
  }

  public ReadAllTemperatureSensor() {
      return this.ask("ReadAllTemperatureSensor");
  }
  public ReadTemperatureBySensor(id: string) {
    return this.ask("ReadTemperatureBySensor", id);
  }

  public StopTemperatureSensor() {
      return this.ask("StopTemperatureSensor");
  }

  public LoginIFTTTCloud = (e_mail: string, password: string) => {
      return this.ask<{ data: IFTTTResponse }>("LoginIFTTTCloud",{e_mail,password}).then(r => r?.data)
  };

  public LogOutIFTTTCloud () {
      return this.ask("LogOutIFTTTCloud");
  }

  public ReadCameraResolution (id: string) {
      return this.ask<{data: CameraResolution}>("ReadCameraResolution", id).then(r => r?.data)
  }

  public ResetUserPassword(user_name?: string, current_password?: string, new_password?: string, auth_code?: string, alarm_password?: string, first_login?: boolean) {
      return this.ask("ResetUserPassword", {
          user_name,
          current_password,
          first_login,
          new_password,
          auth_code,
          alarm_password,
      })
  }
  public getCallList() {
      return this.ask<{data: CallListModel[]}>("GetCallList").then(r => r?.data.sort((a, b) => a?.button.localeCompare(b?.button)))
  }

  public deleteCallList(id: string) {
      return this.ask("DeleteCallList", id)
  }

  public updateCallList(callListList: CallListModel) {
      return this.ask<string>("UpdateCallList", callListList)
  }

  public setLanguage(selectedLanguage: SetLanguage) {
      return this.ask("SetLanguage", selectedLanguage)
  }

  public startScreenBrightnessTest(brightnessValue: number){
      return this.ask("StartScreenBrightnessTest", brightnessValue)
  }

  public playTestSound(name: number, command: string){
      return this.ask("PlayTestSound", {name, command})
  }

  public getCallLogList() {
      return this.ask<{data: CallLogList[]}>("GetCallLogList").then(r => r?.data.sort((a, b) => (a.call_time > b.call_time ? -1 : 1)))
  }

  public updateWorkerConfig (workerConfig: WorkerConfigModel) {
      return this.ask<string>("UpdateWorkerConfig", workerConfig)
  }

  public updateSupervisorConfig (supervisorConfig: SupervisorConfigModel) {
      return this.ask<string>("UpdateSupConfig", supervisorConfig)
  }

  public getWorkerConfig () {
      return this.ask<{data: WorkerConfigModel}>("GetWorkerConfig").then(r => r?.data)
  }

  public getSupConfig () {
      return this.ask<{data: SupervisorConfigModel}>("GetSupConfig").then(r => r?.data)
  }

  public recordTestSound(type: boolean) {
      return this.ask("RecordTestSound", type)
  }

  public getTestSounds() {
      return this.ask<SoundPlayingStatus>("GetAllTestSounds").then(r => r)
  }

  public getSystemInfoInTest() {
      return this.ask<SystemInfoTest>("GetSystemInfoInTest").then(r => r)
  }

  public startStressTest(){
      return this.ask("StartStressTest")
  }

  public updateLocations() {
      return this.ask("UpdateLocationsV2")
  }

  public setSoundLevelOnTestPage(level: number){
      return this.ask<number>("SetSoundLevelOnTestPage", level)
  }

  public setMicLevelOnTestPage(level: number){
      return this.ask<number>("SetMicLevelOnTestPage", level)
  }

  public deleteCallLogList(){
      return this.ask("DeleteCallLogList")
  }

  public downloadBackupConfig(){
      return this.ask("DownloadBackupConfig")
  };

  public uploadBackupConfig(){
      return this.ask("UploadBackupConfig");
  };

  public reCallBackupConfig(){
      return this.ask("ReCallBackupConfig");
  };

  public bootLogList(){
      return this.ask<{data: string[]}>("BootLog").then(r => r?.data)
  }

  public getSSHPortStatus() {
      return this.ask<GatewayModel[]>("GetSSHPortStatus")
  }

  public updateSSHPortStatus(gateway_id: string, ssh_status: boolean) {
      return this.ask("UpdateSSHPortStatus", {gateway_id, ssh_status})
  }

  public getDeviceCount() {
      return this.ask<number>("GetDeviceCount")
  }

  public getControlCount() {
      return this.ask<number>("GetControlCount")
  }

  public getInputCount() {
      return this.ask<number>("GetInputCount")
  }

  public getVirtualControlCount() {
      return this.ask<number>("GetVirtualControlCount")
  }

  public SendTestPing(address: string) {
      return this.ask("SendPing", address)
  }

  public SendTestTraceRoute(address: string) {
      return this.ask("SendTraceRoute", address)
  }

  public SendSpeedTest() {
      return this.ask<SpeedTestModel>("SpeedTest").then(r => r)
  }

  public UpdateVRF = (
      id: string,
      power_status: string,
      whole: number,
      fan_speed: string,
      mode: string,
      ventilate: string,
      flap: string,
  ) => {
      return this.ask<string>("UpdateVrfTemperature", {
          id,
          whole,
          mode,
          fan_speed,
          power_status,
          ventilate,
          flap,
      });
  };

  public getServiceErrorLog() {
      return this.ask<string[]>("GetServiceErrorLog").then(r => r)
  }

  public getServiceAlarmLog() {
      return this.ask<string[]>("GetServiceAlarmLog").then(r => r)
  }

  public getDeviceRFSignalReport() {
      return this.ask<{data: RFTestLogType[]}>("GetDeviceRFSignalReport").then(r => r?.data)
  }

  public getServiceMappingLog() {
      return this.ask<string[]>("GetServiceMappingLog").then(r => r)
  }

  public getMouseCursorVisibility() {
      return this.ask<boolean>("GetMouseCursorVisibility")
  }

  public updateMouseCursorVisibility(status: boolean) {
      return this.ask("UpdateMouseCursorVisibility", status)
  }

  public updateIndicatorStatus(indicator_status: boolean){
      return this.ask("UpdateIndicatorStatus", indicator_status)
  }

  public getAuthorityGroupList() {
      return this.ask<{data: AuthorityModel[]}>("GetAuthorityGroupList").then(r => r.data)
  }

  public updateAuthorityGroup(data: AuthorityModel){
      return this.ask("UpdateAuthorityGroup", data)
  }

  public deleteAuthorityGroup(id: string){
      return this.ask("DeleteAuthorityGroup", id)
  }

  public getAuthorizationOverviewList(){
      return this.ask<{data: AuthorityOverviewList[]}>("GetAuthorizationOverviewList").then(r => r.data)
  }

  public updateAdvancedAuthorizationStatus(status: boolean){
      return this.ask("UpdateAdvancedAuthorizationStatus", status)
  }

  public getHomepageItemsByGatewayStatus() {
      return this.ask<boolean>("GetHomepageItemsByGatewayStatus")
  }

  public setHomepageItemsByGatewayStatus(status: boolean) {
      return this.ask("SetHomepageItemsByGatewayStatus", status)
  }

  public deleteInactiveUsers(){
      return this.ask("DeleteInactiveUsers")
  }

  public getUsbConnectionStatus() {
      return this.ask<boolean>("GetUsbConnectionStatus")
  }

  public updateUsbConnectionStatus(status: boolean) {
      return this.ask("UpdateUsbConnectionStatus", status)
  }

  public updateTimezone(params: DateState) {
      return this.ask("UpdateTimezone", params)
  }

  public updateTimezoneOffset() {
      return this.ask("UpdateTimezoneOffset")
  }

  public getTimezoneList() {
      return this.ask<{data: TimezoneType[]}>("GetTimezoneList").then(response => response?.data)
  }

  public getTimezoneOffset(){
      return this.ask<DateState>("GetTimezoneOffset").then(response => response)
  }

  public getAlarmLog(count: number) {
      return this.ask<{data: AlarmLogs[]}>("GetAlarmLog", count).then(r => r.data.sort((a, b) => a?.timestamp > b?.timestamp ? 1 : -1))
  }

  public getAlarmTimerState() {
      return this.ask<{data: AsyncAlarmState}>("GetAlarmTimerState").then(r => r.data)
  }

  public getCallBlockList() {
      return this.ask<{data: SIPBlockedNumbersState[]}>("GetCallBlockList").then(r => r.data)
  }

  public updateCallBlockList({ number, blocked_count, name, sip_number } : Pick<SIPBlockedNumbersState, 'blocked_count' | 'number' | 'name' | 'sip_number'>) {
      return this.ask("UpdateCallBlockList", {number, name, blocked_count, sip_number})
  }

  public deleteCallBlockNumber(id: string) {
      return this.ask("DeleteCallBlockNumber", id)
  }

  public sendCodeUserNumber(number: string) {
      return this.ask("SendCodeUserNumber", number)
  }

  public validateCode = ({user_id, code}: {user_id: string, code: string}) => {
      return this.ask("ValidateCode", {user_id, code})
  }
  public heartBeatSendOTP(phone_number: string) {
      return this.ask("HeartBeatSendOTP", { phone_number })
  }
  public heartBeatUnregister = ({phone_number, code, user_id }: {phone_number: string, code: string, user_id: string}) => {
      return this.ask("HeartBeatUnregister", {phone_number, code, user_id})
  }
  /*
  public getTemperatureLog(control_id: string, analysis: string, date: string) {
      return this.ask<{data: TempLogType}>("GetTemperatureLog", {control_id, analysis, date}).then(values => values.data)
  }
  */

  public getBoostedDeviceList() {
      return this.ask<{data: BoosterModel[]}>("GetBoostedDeviceList").then(r => r.data)
  }

  public deleteDeviceFromBoostList(id: string) {
      return this.ask("DeleteDeviceFromBoostList", id)
  }

  public updateBoostedDeviceList = ({ id, boosted_device_id, booster_id }: BoosterModel) => {
      return this.ask("UpdateBoostedDeviceList", {id, boosted_device_id, booster_id})
  }

  public updateSipFormat = ({ id, format, format_lenght, name }: SIPFormatType) => {
      return this.ask("UpdateSipFormat", {id, format, format_lenght, name})
  }

  public deleteSipFormat(id: string) {
      return this.ask("DeleteSipFormat", id)
  }

  public getSipFormatList() {
      return this.ask<{data: SIPFormatType[]}>("GetSipFormatList").then(r => r.data)
  }

  public checkUserAuthorization() {
      return this.ask<{can_not_access: boolean}>("CheckUserAuthorization").then(r => r.can_not_access)
  }

  public updateMediaFile = (type: string, data: string | ArrayBuffer, tags: string[]) => {
      return this.ask("UpdateMediaFile", {type, data, tags})
  }

  public getSunriseSunset() {
      return this.ask<{data: SunTimeType}>("GetSunriseSunset").then(r => r.data)
  }

  public getNotificationLog(dataLength: number) {
      return this.ask<{data: NotificationLogType[]}>("GetNotificationLog", dataLength).then(values => values.data)
  }

  public updateKeypadInputSettings = ({input_id, name, direction, pin}:{input_id: string, name: string, direction: number, pin: string}) => {
      return this.ask("UpdateKeypadInputSettings", {input_id, name, direction, pin})
  }

  public updateKeypadSettings = ({
      bridge_device_id, touch_feedback, buzzer_status, is_passive
  }: {
      bridge_device_id: string, touch_feedback: boolean, buzzer_status: boolean,
      is_passive: boolean
  }) => {
      return this.ask("UpdateKeypadSettings", {
          bridge_device_id, touch_feedback, buzzer_status, is_passive
      })
  }


  public setDetailRfTest = ({device_rf_address, related_gateway, number_of_packet, repeat, period, halt_on_error}:DetailedRFTestModel) => {
      return this.ask("DetailRfTest", {
          device_rf_address,
          related_gateway,
          number_of_packet,
          repeat,
          period,
          halt_on_error
      })
  }

public getFrameUIList() {
  return this.ask<{ data: FrameUIEntity[] }>("GetFrameUIList").then(r => r.data)
}

public getAnalogSensorTypeList() {
  return this.ask<{ data: AnalogSensorTypeModel[] }>("GetAnalogSensorTypeList").then(r => r.data)
}

  public deleteFrameUI(id: string) {
      return this.ask("DeleteFrameUI", id)
  }

  public updateFrameUI = (frameEntitity: FrameUIEntity) => {
      return this.ask("UpdateFrameUI", frameEntitity)
  }
  public updateSystemRestartSettings = ({is_enabled, desktop, services, rtspV2_service, time}: AutoRestart) => {
      return this.ask("UpdateSystemRestartSettings", {is_enabled, desktop, services, rtspV2_service, time})
  }

  public wifiOn = (gatewayId: string) => {
      return this.ask("WifiOn", gatewayId)
  }

  public wifiOff = (gatewayId: string) => {
      return this.ask("WifiOff", gatewayId)
  }

  public updateChangeOrder = ({type, is_auto_sorting, relational_id, order}: SortingItemModel) => {
      return this.ask("ChangeOrder", {type, is_auto_sorting, relational_id, order})
  }

public getManualBackupLog() {
  return this.ask("ManualBackupLog")
}

public getLucentRGBSettings() {
  return this.ask<{ data: LucentRGBSettingsModel[] }>("GetLucentRGBSettings").then(
    r => r.data.sort((a, b) => (a.id > b.id ? -1 : 1))
  )
}

public setLucentRGBSettings(id: string) {
  return this.ask("SetLucentRGBSettings", id)
}

public setLucentButtonColor(
  type: string,
  mode: string | null,
  color: RgbColor,
  bridge_device_list: string[]
) {
  const methodName = type === 'primary' ? 'SetLucentPrimaryButtonColor' : 'SetLucentActiveButtonColor';
  const payload: any = { color, bridge_device_list };
  if (mode !== null) { payload.mode = mode; }
  return this.ask(methodName, payload);
}

public updateLucentRGBSettings(
  id: string | undefined,
  name: string,
  primary_button_color: {
    is_enabled: boolean,
    mode: string,
    color: RgbColor,
    bridge_device_list: string[]
  },
  active_button_color: {
    is_enabled: boolean,
    color: RgbColor,
    bridge_device_list: string[]
  }
) {
  return this.ask("UpdateLucentRGBSettings", {
    name, id,
    primary_button_color,
    active_button_color
  })
}

public deleteLucentRGBSettings(id: string) {
  return this.ask("DeleteLucentRGBSettings", id)
}

public loginNovaCloud({ email, password }: { email: string, password: string }) {
  return this.ask("LoginNovaCloud", { email, password })
}

public getCloudConfig() {
  return this.ask<{data: {
    cloud_device_management: any;
    access_token: boolean,
    email: string,
    is_enabled: boolean,
    is_panel_added: boolean
  }}>("GetCloudConfig").then(r => r.data)
}

public logoutNovaCloud(boolean) {
  return this.ask("LogoutNovaCloud", boolean)
}

public getCloudStatus() {
  return this.ask("GetCloudStatus", {})
}

public setCloudStatus(is_enabled: boolean) {
  return this.ask("SetCloudStatus", { is_enabled })
}

public getCloudConnectionTest(gateway_id: string) {
    return this.ask("CloudConnectionTest", gateway_id)
}

public authenticateWithPinCode(pincode: string) {
    return this.ask<AuthenticatedWithPinCodeResponse>("AuthenticateWithPinCode", pincode).then(res => res);
}


public updateBackgroundImage(background_image_id: string) {
  return this.ask("UpdateBackgroundImage", background_image_id)
}

public getConnectionServices() {
    return this.ask("GetConnectionServices")
}

public updateConnectionServices() {
    return this.ask("UpdateConnectionServices")
}

public getSystemRestartSettings() {
  return this.ask<SystemRestart>("GetSystemRestartSettings")
}

public getWorkerConfigPanelSettings() {
    return this.ask<WorkerConfigPanelSettings>("GetWorkerConfigPanelSettings")
}

public deleteControlIconType(id: string){
  return this.ask("DeleteControlIconType", id);
}
public frontendErrorLog(error: string) {
    return this.ask("LogFrontendError", error)
}

public GetOnboardingList() {
    return this.ask<OnboardingUser>("GetOnboardingList").then(r => r);
}

public resetCloudUserAlarmPassword(user_name: string, alarm_password: string) {
    return this.ask("ResetCloudUserAlarmPassword", {user_name, alarm_password})
}
public getSimpleConnectionsLog() {
    return this.ask<{ data: string }>("GetSimpleConnectionsLog").then((r) => r.data);
}

public getUpdateStatus() {
    return this.ask("GetUpdateStatus", {})
}

public checkVersion() {
    return this.ask("CheckVersion", {})
}

public downloadNewVersion() {
    return this.ask("DownloadNewVersion", {})
}

public checkSystemsReady() {
    return this.ask("CheckSystemsReady", {})
}

public updateSystem() {
    return this.ask("UpdateSystem", {})
}

public getVersionStatus() {
    return this.ask("GetVersionStatus", {})
}
}